export const authHandler = {
    pathPattern: '/reset-password',
    toWeb: () => ({ path: '/reset-password' }),
    meta: {
        title: 'Auth (reset / MFA / login link)',
        description: 'Password reset, multi-factor verification, and Hestia magic-login links. Intentionally web-first.',
        status: 'live',
        platforms: { web: true, ios: false, android: false },
        flag: null,
        params: [{ name: 'token', in: 'query', required: true }],
        example: { params: {}, query: { token: 'exampleToken' } },
    },
};
//# sourceMappingURL=auth.js.map